module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-SemiBold.woff2?a553f44ac2c2f8ffdb1290d33b7c2425";